import React, { useRef } from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { ApplicationUuid, Task } from '@bringg/types';
import classNames from 'classnames';
import { getTaskStatusClass, taskStyles } from '@bringg-frontend/monitoring';

import { useStores } from 'bringg-web/recipes';
import { MAX_ITEM_IN_VIEW, taskTooltipFooterProvider } from './task-tooltip-footer-provider';
import useRouteMonitoringStore from '../../../../../routes-monitoring-screen/stores/helpers/use-route-monitoring-store';

import styles from './task-tooltip-footer.module.scss';

interface Props {
	tasks: Task[];
	currentTaskIndex: number;
	tasksLength: number;
	toggleTask: (taskIndex: number, e: React.MouseEvent, isBreak?: boolean) => void;
}

const TaskTooltipFooter = ({ tasks, currentTaskIndex, tasksLength, toggleTask }: Props) => {
	const footerRef = useRef<HTMLDivElement>();
	const { merchantConfigurationsStore } = useStores();
	const {
		selectedTasksStore: { isTaskSelected }
	} = useRouteMonitoringStore();
	const isRealtimeEtaEnabled = !!merchantConfigurationsStore.findApplication(ApplicationUuid.RealtimeEtaApp);

	const getTaskElement = (task: Task, index: number) => (
		<div
			key={task.id}
			className={classNames(styles.taskButton, getTaskStatusClass(task, isRealtimeEtaEnabled), {
				[taskStyles.selectedTask]: isTaskSelected(task.id)
			})}
			onClick={(e: React.MouseEvent) => {
				toggleTask(index, e);
			}}
			title={`${task.priority}`.length > 2 ? `${task.priority}` : undefined}
			data-test-id={`tooltip-task-${task.id}`}
		>
			<span className={styles.btnText}>{task.priority}</span>
		</div>
	);

	const getBreakElement = (index: number) => (
		<div
			key={`break_${index}`}
			className={styles.taskButton}
			onClick={(e: React.MouseEvent) => {
				toggleTask(index, e, true);
			}}
			data-task-index={index}
			data-test-id={`tooltip-page-break-${index}`}
		>
			<BringgIcon iconName={BringgFontIcons.MenuHorizontal} />
		</div>
	);

	const renderTaskPagination = () => {
		const paginationItems = taskTooltipFooterProvider.getPaginationItems(currentTaskIndex, tasksLength);

		return paginationItems.map(({ type, index }) => {
			if (type === 'page') {
				return getTaskElement(tasks[index], index);
			}

			return getBreakElement(index);
		});
	};

	return (
		<div
			ref={footerRef}
			className={classNames(styles.tooltipFooter, taskStyles.tasksTimeline)}
			data-test-id="tasks-tooltip-footer"
		>
			{tasks.length < MAX_ITEM_IN_VIEW ? tasks.map(getTaskElement) : renderTaskPagination()}
		</div>
	);
};

export default TaskTooltipFooter;
